export default "__VITE_ASSET__Dulx1Lwg__"